import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Alert = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <path
            fillRule="evenodd"
            d="M22 7.132V4h4v3.132C33.339 8.11 39 14.394 39 22v11h1.013c1.105 0 1.987.91 1.987 2.015C42 36.09 41.12 37 40.015 37H7.985C6.88 37 6 36.09 6 34.985 6 33.91 6.882 33 7.987 33H9V22c0-7.606 5.661-13.89 13-14.868ZM13 33h22V22c0-6.075-4.925-11-11-11s-11 4.925-11 11v11Zm18 9.015C31 43.09 30.13 44 29.025 44h-10.05C17.87 44 17 43.09 17 41.985 17 40.91 17.87 40 18.975 40h10.05C30.13 40 31 40.91 31 42.015"
            style={{ mixBlendMode: 'passthrough' }}
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
